import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { WebSocketService } from 'app/EMR/webSocket.Service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { AuthService } from 'app/auth/auth.service';
/**
 * Food data with nested structure.
 * Each node has a name and an optional list of children.
 */

interface FileWithPath extends File {
  webkitRelativePath: string;
}
interface FileWithPreview {
  file: FileWithPath;
  url?: string; // base64 string
}
// interface FoodNode {
//   name: string;
//   children?: FoodNode[];
// }
// const TREE_DATA: FoodNode[] = [
//   {
//     name: 'D:',
//     children: [
//       {
//         name: 'NetramAK',
//         children: [{ name: 'A-Scan' }, { name: 'Image' }],
//       },
//     ],
//   },
// ];

/** Flat node with expandable and level information */
// interface ExampleFlatNode {
//   expandable: boolean;
//   name: string;
//   level: number;
// }

/**
 * @title Tree with flat nodes
 */
@Component({
  selector: 'app-file-transfer',
  templateUrl: './file-transfer.component.html',
  styleUrls: ['./file-transfer.component.scss']
})

export class FileTransferComponent implements OnInit {

  selectedFiles: FileWithPreview[] = [];
  allFiles: FileWithPath[] = [];
  fileNameurl: String = '';
  dataSourceArray: any[] = [];
  procedreid: any;
  branchid: any;
  constructor(public dialogRef: MatDialogRef<FileWithPath>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private webSocketService: WebSocketService, private dashboardService: DashboardService,private authService:AuthService) {
    // this.dataSource.data = TREE_DATA;
  }// Implement this method (and others if needed)

  ngOnInit(): void {
    debugger
    this.fileNameurl = this.data.filepath ? this.data.filepath : '';
    this.procedreid = this.data.pid ? this.data.pid : 0;
    this.branchid = this.data.bid ? this.data.bid : 0;
    this.dataSourceArray = this.data.getdata ? this.data.getdata : [];
    console.log(this.dataSourceArray);
  }
  getprocedureFiledata() {
    this.dataSourceArray = [];
    const msg = {
      "message": "UPLOADFILE",
      "ACTIONTYPE": "VIEW",
      "DOCUMENTTYPE": 'PROCEDUREIMAGES',
      "BranchId": this.branchid.toString(),
      "PATIENTID": this.procedreid.toString(),
      "MAINIMAGEPATH": this.fileNameurl
    }
    this.webSocketService.sendMessage(msg);
    this.webSocketService.getMessages().subscribe(
      (message: any) => {
       
        const filedat = message;
        this.webSocketService.disconnect();
        if (filedat.length > 0) {
          this.dataSourceArray = message;
          if (this.dataSourceArray.length > 0) {
            for (var i = 0; i < this.dataSourceArray.length; i++) {

              if (this.dataSourceArray[i].fbLong) {
                this.dataSourceArray[i].selectfile = false;
                const splitdat = this.dataSourceArray[i].fbLong.split(/[:;,]+/);
                if (splitdat[1] == 'application/pdf') {
                  this.dataSourceArray[i].thubnail = './assets/img/icons/icon-pdf.png' + "?" + Math.floor(Math.random() * 100) + 1;
                } else {
                  this.dataSourceArray[i].thubnail = './assets/img/icons/icons-image.png' + "?" + Math.floor(Math.random() * 100) + 1;
                }
              }
            }
          }
        }

      }, err => {
        this.dashboardService.openSnackBar("Please set server configuration", "OK");
      });


  }

  removeprocedurefiledata(file: any) {
    const msg = {
      "message": "UPLOADFILE",
      "ACTIONTYPE": "DELETE",
      "DOCUMENTTYPE": 'PROCEDUREIMAGES',
      "DOCUMENTNAME": file.documentName,
      "BranchId": this.branchid.toString(),
      "PATIENTID": this.procedreid.toString(),
      "MAINIMAGEPATH": this.fileNameurl
    }
    this.webSocketService.sendMessage(msg);
    this.webSocketService.getMessages().subscribe(
      (message: any) => {
        if (message) {
          this.dashboardService.openSnackBar(message, "OK");
          this.webSocketService.disconnect();
          setTimeout(() => {
            this.getprocedureFiledata();
          }, 500);

        }
      }, err => {
        this.dashboardService.openSnackBar("Please set server configuration", "OK");
      });

  }

  closedialog() {
    this.dialogRef.close({ success: true, data: this.dataSourceArray });
  }
  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.allFiles = Array.from(input.files) as FileWithPath[];
    }
  }

  onFolderSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    
    if (input.files) {
     // this.allFiles = Array.from(input.files) as FileWithPath[];
     this.allFiles = [...this.allFiles, ...Array.from(input.files) as FileWithPath[]];
    }
  }
 
  toggleFileSelection(file: FileWithPath): void {
    const index = this.selectedFiles.findIndex(f => f.file.webkitRelativePath === file.webkitRelativePath);
  
    if (index > -1) {
      this.selectedFiles.splice(index, 1); // Deselect
    } else {
      const fileWithPreview: FileWithPreview = { file };
      this.selectedFiles.push(fileWithPreview); // Add the file first
  
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        const splitdata = event.target.result.split(',');
        fileWithPreview.url = splitdata[1]; // Update base64 in-place
      };
    }
  }
  

  isFileSelected(file: FileWithPath): boolean {
    return this.selectedFiles.some(f => f.file.webkitRelativePath === file.webkitRelativePath);
  }
  //file view mode 
  viewedFile: FileWithPath | null = null;
  // fileURL: SafeResourceUrl | null = null;
  originalBlobURL: string | null = null;
  fileTextContent: string = '';
  viewFile(file: FileWithPath): void {
    this.viewedFile = file;

    if (this.originalBlobURL) {
      URL.revokeObjectURL(this.originalBlobURL);
    }

    const objectURL = URL.createObjectURL(file);
    this.originalBlobURL = objectURL; // store original

    window.open(this.originalBlobURL);


  }
  public messageList: string[] = [];
  fileTransferdata(){
   
   // if(this.authService.webstorageConfigobj.storageType.toLowerCase() =='imageserver'){
      if(this.selectedFiles.length >0){
        var payloaddat=[];
        this.selectedFiles.forEach(item=>{
          let rp={
            "DOCUMENTNAME": String(item.file.name),
            "CLIENTFILE": String(item.file.name),
            "fileData": String(item.url),
          }
          payloaddat.push(rp);
        })
      const message = {
        "message": "UPLOADFILE",
        "ACTIONTYPE": "UPLOAD",
        "DOCUMENTTYPE": 'PROCEDUREIMAGES',
        "BranchId": this.authService.Loggeduser.branchid.toString(),
        "PATIENTID": this.procedreid.toString(),
        "MAINIMAGEPATH": this.fileNameurl,
        "CLIENTFOLDERPATH": "D:\\Temp",
        "fileDataArray": payloaddat 
    };
    this.webSocketService.sendMessage(message);
    this.webSocketService.getMessages().subscribe(
      (message: any) => {
        if (message) {
          if (typeof message === 'string') {
            this.messageList = [message]; // store properly into array
          } else if (Array.isArray(message)) {
            this.messageList = message;
          
          }
          this.dashboardService.openSnackBar(this.messageList.join('\n'), "OK");
          this.webSocketService.disconnect();
          setTimeout(() => {
            this.removearraydata();
            this.getprocedureFiledata();
          }, 500);
        }
      },
      err => {
        this.dashboardService.openSnackBar("Please set server configuration", "OK");
      }
    );
      }else{
        this.dashboardService.openSnackBar("Please select file first", "OK");
      }
     
    // }else{
    //   this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
    // }
  }
  
  removearraydata(){
    if(this.selectedFiles.length >0){
      this.selectedFiles.forEach(item=>{
       this.allFiles =this.allFiles.filter(item1=>item1.name != item.file.name); 
      });
    }
    this.selectedFiles=[];
  }

  //below demo code 
  // private _transformer = (node: FoodNode, level: number) => {
  //   return {
  //     expandable: !!node.children && node.children.length > 0,
  //     name: node.name,
  //     level: level,
  //   };
  // };


  // treeControl = new FlatTreeControl<ExampleFlatNode>(
  //   node => node.level,
  //   node => node.expandable,
  // );

  // treeFlattener = new MatTreeFlattener(
  //   this._transformer,
  //   node => node.level,
  //   node => node.expandable,
  //   node => node.children,
  // );

  // dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);


  // hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

}
